import { useEffect } from 'react';
import { useAuth } from '../context/auth.context';
import LoginLoader from './login-loader.component';

const LogoutCallback = () => {
  const { signoutRedirectCallback } = useAuth();

  useEffect(() => {
    signoutRedirectCallback();
  });

  return <LoginLoader title="Redirecting to login" />;
};
export default LogoutCallback;
